/** Material presets for the coax fills and conductors. */
import type { CondProps, DielProps } from "./fill";

export interface DielPreset {
  id: string;
  name: string;
  er: number;
  tand: number;
}

export const DIELECTRIC_PRESETS: DielPreset[] = [
  { id: "air", name: "Air", er: 1.0006, tand: 0 },
  { id: "ptfe", name: "PTFE", er: 2.1, tand: 2e-4 },
  { id: "foam-ptfe", name: "Foam PTFE", er: 1.5, tand: 1.5e-4 },
  { id: "pe", name: "Polyethylene", er: 2.26, tand: 3e-4 },
  { id: "foam-pe", name: "Foam PE", er: 1.6, tand: 2e-4 },
  { id: "pp", name: "Polypropylene", er: 2.25, tand: 4e-4 },
  { id: "fr4", name: "FR-4", er: 4.4, tand: 0.02 },
  { id: "alumina", name: "Alumina (96%)", er: 9.6, tand: 2e-4 },
];

export function dielFromPreset(id: string): DielProps {
  const p = DIELECTRIC_PRESETS.find((x) => x.id === id) ?? DIELECTRIC_PRESETS[1]!;
  return { er: p.er, tand: p.tand, presetId: p.id };
}

export interface CondPreset {
  id: string;
  name: string;
  sigma: number;
}

export const CONDUCTOR_PRESETS: CondPreset[] = [
  { id: "copper", name: "Copper", sigma: 5.8e7 },
  { id: "aluminum", name: "Aluminum", sigma: 3.77e7 },
  { id: "gold", name: "Gold", sigma: 4.1e7 },
  { id: "silver", name: "Silver", sigma: 6.3e7 },
  { id: "pec", name: "PEC (lossless)", sigma: 0 },
];

export function condFromPreset(id: string): CondProps {
  const p = CONDUCTOR_PRESETS.find((x) => x.id === id) ?? CONDUCTOR_PRESETS[0]!;
  return { sigma: p.sigma, muR: 1, roughnessUm: 0, roughnessModel: "hammerstad", presetId: p.id };
}
